import { render, staticRenderFns } from "./clear-cookie.vue?vue&type=template&id=4ef23946&scoped=true&"
import script from "./clear-cookie.vue?vue&type=script&lang=js&"
export * from "./clear-cookie.vue?vue&type=script&lang=js&"
import style0 from "./clear-cookie.vue?vue&type=style&index=0&id=4ef23946&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef23946",
  null
  
)

export default component.exports